
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PatientMergePreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetPatientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourcePatientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"patientMergePreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"targetPatientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetPatientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourcePatientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourcePatientId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"consultationsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"appointmentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attachmentsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"downloadContainersCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"informationClarificationsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userInvitationsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"usersCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baseDataConflicts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetValue"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceValue"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"anamnesisChoiceRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"targetAnamnesisUpdatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceAnamnesisUpdatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceHasInternalId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sourceInternalId"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":552}};
    doc.loc.source = {"body":"query PatientMergePreview($targetPatientId: ID!, $sourcePatientId: ID!) {\n  patientMergePreview(targetPatientId: $targetPatientId, sourcePatientId: $sourcePatientId) {\n    consultationsCount\n    appointmentsCount\n    attachmentsCount\n    downloadContainersCount\n    informationClarificationsCount\n    userInvitationsCount\n    usersCount\n    baseDataConflicts {\n      field\n      targetValue\n      sourceValue\n    }\n    anamnesisChoiceRequired\n    targetAnamnesisUpdatedAt\n    sourceAnamnesisUpdatedAt\n    sourceHasInternalId\n    sourceInternalId\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PatientMergePreview"] = oneQuery(doc, "PatientMergePreview");
        
